import { TaskManagementService } from 'app/modules/task/services/task-management.service';
import { Component, OnInit } from '@angular/core';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { UntypedFormControl } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { PeriodRadio } from 'app/modules/common/enums/actuation-filter-enums';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-actuation-selection-filter',
    templateUrl: './actuation-selection-filter.component.html',
    styleUrls: ['./actuation-selection-filter.component.scss'],
    standalone: false
})
export class ActuationSelectionFilterComponent implements OnInit {
    DateFilterType = DateFilterTypes;
    CommonDateFrom = new UntypedFormControl();
    CommonDateTo = new UntypedFormControl();

    DoctorList$: any[];
    CoordinatorList$: any[];
    OrdenList$: any[];

    radioSelected: string;
    ActiveLeaves: boolean;
    EmpresaSelec: boolean = true;
    Orden: string;
    Autor: string;
    Coordinator: string;
    isShowRevisar: boolean;
    autores : string[];

    CurrentUser: any;

    responsibleAuthorTypes:string;
    responsibleModuleName:string;

    constructor(
        public selectionService: SelectionGenericService,
        public filterService: FilterService,
        private sharedService: SharedService,
        public taskManagementService: TaskManagementService
    ) {
        this.taskManagementService.initTaskForm(1);
        this.radioSelected = PeriodRadio.Actuacion.toString();
        this.ActiveLeaves = true;
        this.Orden = 'Empresa';
        this.autores = new Array<string>();
    }

    ngOnInit(): void {
        this.autores = new Array<string>();
        this.selectionService.ActuationSelectionModal.AutorMultiple = new Array<number>();
        this.selectionService.ActuationSelectionModal.EmpresaSelec = this.EmpresaSelec;
        this.responsibleAuthorTypes="GMCEUD"
        this.responsibleModuleName="task-selection";

        this.CurrentUser = this.sharedService.getCurrentUser();
        this.isShowRevisar = this.CurrentUser.coordinador !== null;

        this.OrdenList$ = [
            { text: 'Empresa', value: 'Empresa' },
            { text: 'Trabajador', value: 'Trabajador' },
            { text: 'Fecha', value: 'Fecha' },
            { text: 'Autor', value: 'Autor' },
            { text: 'Fecha Registro', value: 'FechaRegistro' },
            { text: 'Usuario', value: 'Usuario' },
        ];
        this.selectionService.GetDoctorList().subscribe(
            (res) => {
                if (res.code === 0) {
                    this.DoctorList$ = res.result;
                }
            },
            (error) => {
                console.error(error);
            }
        );

        this.selectionService.GetCoordinatorList().subscribe(
            (res) => {
                if (res.code === 0) {
                    this.CoordinatorList$ = res.result;
                }
            },
            (error) => {
                console.error(error);
            }
        );

        this.selectionService.ActuationSelectionModal.IsSoloBajasActivas = true;
        this.selectionService.ActuationSelectionModal.IsActuacion = true;
        this.selectionService.ActuationSelectionModal.Orden = 'Empresa';
    }

    public SetFilterValues(filterType: string, data: Date = null): void {
        switch (filterType) {
            case 'PeriodRadio':
                if (this.radioSelected === PeriodRadio.Actuacion.toString()) {
                    this.selectionService.ActuationSelectionModal.IsActuacion =
                        true;
                    this.selectionService.ActuationSelectionModal.IsRegistro =
                        false;
                } else {
                    this.selectionService.ActuationSelectionModal.IsRegistro =
                        true;
                    this.selectionService.ActuationSelectionModal.IsActuacion =
                        false;
                }
                break;
            case 'commonDateFrom':
                this.selectionService.ActuationSelectionModal.CommonDateFrom =
                    DateHelper.getUTCDateString(data);
                break;

            case 'commonDateTo':
                this.selectionService.ActuationSelectionModal.CommonDateTo =
                    DateHelper.getUTCDateString(data);
                break;

            case 'activeLeaves':
                this.selectionService.ActuationSelectionModal.IsSoloBajasActivas =
                    this.ActiveLeaves;
                break;

            case 'empresaSelec':
                this.selectionService.ActuationSelectionModal.EmpresaSelec = this.EmpresaSelec;
                break;

            case 'Orden':
                this.selectionService.ActuationSelectionModal.Orden =
                    this.Orden;
                break;
            case 'IsRevisor':
                this.selectionService.ActuationSelectionModal.IsRevisar =
                    this.filterService.IsRevisor;
                break;
            case 'Coordinator':
                this.selectionService.ActuationSelectionModal.CoordinatorMain =
                    this.Coordinator;
                break;
            default:
                break;
        }
    }

    public onChangeAutor(name: string, data: any = null): void {
        this.selectionService.ActuationSelectionModal.MedicoId = null;
        if (!this.autores) {
            this.autores = new Array<string>();
        }
        switch (name) {
            case 'Autor':
                this.selectionService.ActuationSelectionModal.TipoAutor = data
                    ? data
                    : null;
                if (data === 'Yo') {
                    this.selectionService.ActuationSelectionModal.Autor =
                        this.CurrentUser.abreviacion;
                } else if (data === 'G') {
                    this.selectionService.ActuationSelectionModal.AutorMultiple = new Array<number>();
                    this.selectionService.ActuationSelectionModal.Autor = null;
                } else if (data === 'M') {
                    this.selectionService.ActuationSelectionModal.MedicoId =
                        this.CurrentUser.medicoId;
                } else if (data === 'C') {
                    this.selectionService.ActuationSelectionModal.Autor =
                        this.CurrentUser.coordinador;
                } else if (data === 'D') {
                    this.selectionService.ActuationSelectionModal.AutorMultiple = new Array<number>();
                    this.selectionService.ActuationSelectionModal.Autor = null;
                }
                break;
            case 'User':
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    this.selectionService.ActuationSelectionModal.AutorMultiple = data;
                }else{
                    this.selectionService.ActuationSelectionModal.Autor = data;
                }
                break;
            case 'Medico':
                this.selectionService.ActuationSelectionModal.Autor =
                    data.selectedViewValue;
                this.selectionService.ActuationSelectionModal.MedicoId =
                    data.selectedValue;
                break;
            case 'Coordinator':
                this.selectionService.ActuationSelectionModal.Autor = data;
                break;
        }


    }
}
